import {
  faCircleCheck,
  faCircleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal, Vertical } from 'atoms/layout/flex';
import { BodyM, BodyS, HeadlineXS, LabelS } from 'atoms/typography';
import {
  SecurityCheckTab,
  useAccountSecurityCheckContext,
} from 'contexts/accountSecurityCheck';
import { useCurrentUserContext } from 'contexts/currentUser';
import { glossary } from 'lib/glossary';

const Badge = styled.div<{ enabled: boolean }>`
  color: ${({ enabled }) =>
    enabled ? 'var(--c-onBase-success)' : 'var(--c-red-300)'};
  display: inline-block;
  padding: 0 var(--half-unit);
  gap: var(--double-unit);
  border: solid 1px currentColor;
  border-radius: var(--half-unit);
`;
const RecoveryCodes = styled.div`
  border-top: solid 1px var(--c-nd-200);
  padding-top: var(--double-unit);
`;

export const TwoFA = () => {
  const { setSecurityCheckTab } = useAccountSecurityCheckContext();

  const { currentUser } = useCurrentUserContext();
  if (!currentUser) return null;
  const { otpRequiredForLogin } = currentUser;

  return (
    <Vertical gap={2}>
      <Vertical>
        <Horizontal>
          {otpRequiredForLogin ? (
            <FontAwesomeIcon
              icon={faCircleCheck}
              color="var(--c-onBase-success)"
            />
          ) : (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              color="var(--c-red-500)"
            />
          )}
          <HeadlineXS as="h6" color="var(--c-white)">
            <FormattedMessage
              id="accountSecurityCheck.2fa.title"
              defaultMessage="Two-Factor Authentication"
            />
          </HeadlineXS>
        </Horizontal>
        {!otpRequiredForLogin && (
          <BodyS color="var(--c-nd-600)">
            <FormattedMessage
              id="accountSecurityCheck.2fa.desc"
              defaultMessage="Two-factor authentication (known as “2FA”) adds an extra layer of security to your account to ensure that only you have the ability to log in."
            />
          </BodyS>
        )}
      </Vertical>
      <div>
        <BodyM color="var(--c-white)">
          <FormattedMessage
            id="accountSecurityCheck.2fa.authenticatorApp"
            defaultMessage="Authenticator app"
          />
        </BodyM>
        <Badge enabled={otpRequiredForLogin}>
          <LabelS bold>
            {otpRequiredForLogin ? (
              <FormattedMessage {...glossary.enabled} />
            ) : (
              <FormattedMessage {...glossary.disabled} />
            )}
          </LabelS>
        </Badge>
      </div>
      {!!otpRequiredForLogin && (
        <RecoveryCodes>
          <BodyM color="var(--c-white)">
            <FormattedMessage
              id="accountSecurityCheck.2fa.codes"
              defaultMessage="Recovery codes"
            />
          </BodyM>
          <Badge enabled>
            <LabelS bold>
              <FormattedMessage {...glossary.viewed} />
            </LabelS>
          </Badge>
        </RecoveryCodes>
      )}
      {!otpRequiredForLogin && (
        <BodyM color="var(--c-link)">
          <button
            type="button"
            onClick={() => setSecurityCheckTab(SecurityCheckTab.ENABLE_2FA)}
          >
            <FormattedMessage
              id="accountSecurityCheck.2fa.enable"
              defaultMessage="Enable 2FA"
            />
          </button>
        </BodyM>
      )}
    </Vertical>
  );
};
